import * as React from 'react';
import LoadingContent from 'automaailm-ui/lib/Components/LoadingContent';

export const ContentLoading = () => <LoadingContent />;
